// extracted by mini-css-extract-plugin
export default {"meal":"mealItem_meal__4+ToF","description":"mealItem_description__Kqam8","price":"mealItem_price__m6Pc3"};